import { VALIDATION_CODE } from '~publish/legacy/validation/constants'
import ValidationFail from '~publish/legacy/validation/ValidationFail'
import ValidationSuccess from '~publish/legacy/validation/ValidationSuccess'
import { type MinSizeRule, ValidationRuleName } from '../types'
import { createRuleHandler } from './createRuleHandler'
import { getRuleMessages } from './getRuleMessages'

export const minSize = createRuleHandler<MinSizeRule>({
  ruleName: ValidationRuleName.MinSize,

  messages: {
    specific: 'File size is below the minimum limit ({min} KB)',
    generic: 'One or more images are below the minimum limit ({min} KB)',
  },

  validate: (rule, media) => {
    const { min } = rule.ruleConfig

    if (Number(media.size) < Number(min)) {
      const messages = getRuleMessages(rule)
      return new ValidationFail(
        messages.generic,
        VALIDATION_CODE.FILE_SIZE,
        messages,
        {},
      )
    }

    return new ValidationSuccess()
  },
})
